'use strict'

import $ from 'jquery'

export default class TtProducts {
  constructor () {
    $('.single-blog .product-images .main-picture').click(function (e) {
      e.preventDefault()

      $('.thumbnail li:first-child > a', $(this).parent()).trigger('click')
    })

    $('.fancy').fancybox()
  }
}
